import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_3 = {
  filter: "productionPhase",
  sort: "productionPhase"
}
const _hoisted_4 = {
  filter: "position",
  filterType: "number",
  sort: "position"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { colspan: "10" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Production Phase configuration",
        text: "Production Phase configuration",
        class: "mb-0"
      }),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editConfiguration(null)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Add Configuration",
          text: "Add Configuration"
        })
      ])
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_op_table, {
            class: "table table-striped",
            items: _ctx.items
          }, {
            default: _withCtx((opData) => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_3, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Production Phase",
                      text: "Production Phase"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_4, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Position",
                      text: "Position"
                    })
                  ]),
                  _hoisted_5
                ])
              ]),
              _createElementVNode("tbody", null, [
                (opData.data.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                      _createElementVNode("td", _hoisted_7, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "No Elements Found",
                          text: "No Elements Found"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.ProductionPhaseConfigurationVM[]), (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(item.productionPhase), 1),
                    _createElementVNode("td", null, _toDisplayString(item.position), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: ($event: any) => (_ctx.editConfiguration(item))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Edit",
                          text: "Edit"
                        })
                      ], 8, _hoisted_8)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["items"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}